import { INPUT } from '$gbusiness/enums';
import { input } from '$gbusiness/helpers';
import { insertEmptyOption } from '$gbusiness/helpers/input';
import InputRowModel from '$gbusiness/models/inputRow';
import { searchSharp } from 'ionicons/icons';

export const SERIAL_NUMBER_INPUT = (manual = false) => {
  return [
    ...(manual
      ? []
      : [
          {
            label: '',
            value: 'scanText',
            rows: 6,
            className: 'scan-focus',
            input: INPUT.SCAN,
            scan: {
              enableMobile: false,
              mobileDefault: false,
            },
            placeholder: 'Focus Here and Scan Barcode',
            gridSize: 12,
          },
        ]),
  ];
};

export const SERIAL_FORM = (warehouses): Array<InputRowModel> => [
  {
    items: [
      {
        input: INPUT.TEXT,
        label: 'SCREEN.STORES.COLS.ITEM',
        disableFastField: true,
        disabled: true,
        gridSize: 12,
        value: 'itemName',
      },
      ...(warehouses.length > 0
        ? [
            {
              label: 'SCREEN.BATCH.COLS.WAREHOUSE',
              value: 'warehouseId',
              input: INPUT.SELECT,

              options: warehouses.map((v) => ({
                labelText: v.name,
                value: v.id,
              })),
              gridSize: 12,
              validation: [input.requiredValidation],
            },
          ]
        : []),
      ...SERIAL_NUMBER_INPUT(),
    ],
  },
];

export const SERIAL_SCAN_FORM = ({ items, batches, warehouses, onItemChange }): Array<InputRowModel> => [
  {
    items: [
      {
        input: INPUT.AUTOCOMPLETE,
        label: 'SCREEN.SERIAL.COLS.ITEM',
        disableFastField: true,
        gridSize: 12,
        value: 'item',
        config: {
          optionProp: {
            label: 'name',
            labelText: displayItem,
            value: 'id',
          },
          data: items,
        },
        onChange: ({ value }) => onItemChange(value.id),
        validation: [
          {
            condition: (v) => {
              return !v;
            },
            message: 'REQUIRED',
          },
          // requiredValidation,
        ],
      },
      {
        input: INPUT.SELECT,
        label: 'SCREEN.SERIAL.COLS.RECEIVING',
        disableFastField: true,
        gridSize: warehouses.length > 0 ? 6 : 12,
        value: 'batchId',
        options: insertEmptyOption(
          batches.map((v) => ({
            labelText: `#${v.receiveNo}: ${v.receiveDate}`,
            value: v.id,
          })),
          'None',
        ),
      },
      ...(warehouses.length > 0
        ? [
            {
              label: 'SCREEN.BATCH.COLS.WAREHOUSE',
              value: 'warehouseId',
              input: INPUT.SELECT,

              options: warehouses.map((v) => ({
                labelText: v.name,
                value: v.id,
              })),
              gridSize: 6,
              validation: [input.requiredValidation],
            },
          ]
        : []),
      ...SERIAL_NUMBER_INPUT(),
    ],
  },
];

export const SERIAL_EDIT_FORM = (stores, warehouses): Array<InputRowModel> => [
  {
    items: [
      {
        input: INPUT.AUTOCOMPLETE,
        label: 'SCREEN.SERIAL.COLS.STORE',
        disableFastField: true,
        gridSize: 12,
        value: 'store',
        config: {
          optionProp: {
            label: 'name',
            value: 'id',
          },
          data: stores,
        },
      },
      ...(warehouses.length > 0
        ? [
            {
              label: 'SCREEN.BATCH.COLS.WAREHOUSE',
              value: 'warehouseId',
              input: INPUT.SELECT,

              options: warehouses.map((v) => ({
                labelText: v.name,
                value: v.id,
              })),
              gridSize: 12,
              validation: [input.requiredValidation],
            },
          ]
        : []),
      {
        input: INPUT.TEXT,
        label: 'SCREEN.SERIAL.COLS.SERIALNO',
        gridSize: 12,
        value: 'serialNo',
      },
      {
        label: 'SCREEN.SERIAL.COLS.NOTE',
        value: 'note',
        rows: 5,
        input: INPUT.TEXTAREA,
        placeholder: 'Enter serial numbers here. One per line',
        gridSize: 12,
      },
    ],
  },
];

export const displayItem = (o) => {
  return `${o.sku ? `(${o.sku})` : ''} ${o.name || ''}`;
};

export const SERIAL_FILTER_FORM = ({
  items,
  stores,
  serialStatusOptions,
  onChangeItem,
  categories,
  onChangeStore,
  onChangeCategory,
  onChangeQuery,
  onChangeStatuses,
  isItemPage = false,
}): Array<InputRowModel> => [
  {
    items: [
      {
        label: 'INPUT.LABEL.SEARCH',
        placeholder: 'Search Serial',
        input: INPUT.TEXT,
        gridSize: 3,
        icon: searchSharp,
        enterToSubmit: true,
        value: 'query',
        onChange: onChangeQuery,
      },
      ...(!isItemPage
        ? [
            {
              input: INPUT.AUTOCOMPLETE,
              label: 'SCREEN.SERIAL.COLS.CATEGORY',
              disableFastField: true,
              gridSize: 4,
              value: 'category',
              config: {
                optionProp: {
                  label: 'name',
                  labelText: (o) => `${o.name || ''}`,
                  value: 'id',
                },
                data: categories,
              },
              onChange: onChangeCategory,
            },
            {
              input: INPUT.AUTOCOMPLETE,
              label: 'SCREEN.SERIAL.COLS.ITEM',
              disableFastField: true,
              gridSize: 4,
              value: 'item',
              config: {
                optionProp: {
                  label: 'name',
                  labelText: displayItem,
                  value: 'id',
                },
                data: items,
              },
              onChange: onChangeItem,
            },
            {
              input: INPUT.AUTOCOMPLETE,
              label: 'SCREEN.SERIAL.COLS.STORE',
              disableFastField: true,
              gridSize: 4,
              value: 'store',
              config: {
                optionProp: {
                  label: 'name',
                  value: 'id',
                },
                data: stores,
              },
              onChange: onChangeStore,
            },
          ]
        : []),
      ...(serialStatusOptions && serialStatusOptions.length
        ? [
            {
              input: INPUT.MULTI_SELECT,
              label: 'SCREEN.SERIAL.STATUS',
              value: 'statuses',
              position: 'outlined',
              options: serialStatusOptions,
              validation: [
                {
                  condition: (v) => !v.length,
                  message: 'REQUIRED',
                },
              ],
              gridSize: 6,
              onChange: ({ newValue }) => {
                onChangeStatuses(newValue);
              },
            },
          ]
        : []),
    ],
  },
];

export default SERIAL_FORM;
